import React, { useState } from "react";
import EmojiPicker from "emoji-picker-react";
import toast, { Toaster } from "react-hot-toast";

function Bildirimler() {
  const [emoji, setEmoji] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  const [sendNow, setSendNow] = useState(true); // Hemen şimdi seçeneği
  const [dateTime, setDateTime] = useState(""); // Gün ve saat seçimi
  const [repeat, setRepeat] = useState(false); // Tekrar etme durumu
  const [repeatFrequency, setRepeatFrequency] = useState(""); // Tekrar sıklığı
  const [notifications, setNotifications] = useState([]); // Kurulu bildirimler
  const [notificationHistory, setNotificationHistory] = useState([]); // Geçmiş bildirimler

  const onEmojiClick = (emojiData) => {
    setEmoji(emojiData.emoji);
    setShowPicker(false);
  };

  const confirmNotification = () => {
    toast(
      (t) => (
        <span>
          <b>Bildirimi Göndermek İstiyor Musunuz?</b>
          <div className="mt-2">
            <button
              onClick={() => sendNotification(t.id)}
              className="px-3 py-1 mr-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600"
            >
              Evet
            </button>
            <button
              onClick={() => toast.dismiss(t.id)}
              className="px-3 py-1 text-white bg-gray-400 rounded-lg hover:bg-gray-500"
            >
              Hayır
            </button>
          </div>
        </span>
      ),
      { duration: 5000 }
    );
  };

  const sendNotification = (toastId) => {
    toast.dismiss(toastId);
    toast.loading("Bildirim gönderiliyor...");

    setTimeout(() => {
      const newNotification = {
        title,
        content,
        emoji,
        dateTime: sendNow ? "Hemen Şimdi" : dateTime,
        repeat: repeat ? repeatFrequency : "Tekrar Yok",
      };

      // Kurulu bildirimlere ve geçmişe ekle
      setNotifications((prev) => [...prev, newNotification]);
      setNotificationHistory((prev) => [...prev, { ...newNotification, timeSent: new Date().toLocaleString() }]);

      toast.dismiss();
      toast.success("Bildirim başarıyla gönderildi!");
    }, 2000);
  };

  return (
    <div className="flex flex-col md:flex-row gap-4 p-4 bg-sky-100 rounded-lg shadow-md mx-auto min-h-screen">
      <Toaster position="top-right" reverseOrder={false} />

      {/* Bildirim Gönderme Alanı */}
      <div className="w-full md:w-1/2 p-4 bg-white rounded-lg shadow">
        <h2 className="text-lg font-bold mb-4">Bildirim Gönder</h2>

        <div className="mb-4">
          <button
            onClick={() => setShowPicker(!showPicker)}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
          >
            Emoji Seç
          </button>
          {emoji && <span className="ml-4 text-2xl">{emoji}</span>}
          {showPicker && (
            <div className="absolute z-10 mt-2 bg-white border border-gray-300 rounded-lg shadow-lg">
              <EmojiPicker onEmojiClick={onEmojiClick} />
            </div>
          )}
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 font-medium mb-2">
            Bildirim Başlığı
          </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Başlık girin..."
            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 font-medium mb-2">
            Bildirim İçeriği
          </label>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="İçerik girin..."
            className="w-full p-2 border border-gray-300 rounded-lg h-24 focus:outline-none focus:ring-2 focus:ring-blue-500"
          ></textarea>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 font-medium mb-2">
            Gönderim Zamanı
          </label>
          <div className="flex items-center gap-4">
            <label className="flex items-center">
              <input
                type="radio"
                checked={sendNow}
                onChange={() => setSendNow(true)}
              />
              <span className="ml-2">Hemen Şimdi</span>
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                checked={!sendNow}
                onChange={() => setSendNow(false)}
              />
              <span className="ml-2">Belirli Zaman</span>
            </label>
          </div>
          {!sendNow && (
            <input
              type="datetime-local"
              value={dateTime}
              onChange={(e) => setDateTime(e.target.value)}
              className="mt-2 p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          )}
        </div>

        <div className="mb-4">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={repeat}
              onChange={() => setRepeat(!repeat)}
            />
            <span className="ml-2">Tekrar Etsin</span>
          </label>
          {repeat && (
            <select
              value={repeatFrequency}
              onChange={(e) => setRepeatFrequency(e.target.value)}
              className="mt-2 p-2 border border-gray-300 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Seçim Yapın</option>
              <option value="Günlük">Günlük</option>
              <option value="Haftalık">Haftalık</option>
              <option value="Aylık">Aylık</option>
              <option value="Yıllık">Yıllık</option>
            </select>
          )}
        </div>

        <button
          onClick={confirmNotification}
          className="py-2 px-4 bg-blue-500 text-white font-bold rounded-lg hover:bg-blue-600 transition"
        >
          Bildirimi Gönder
        </button>
      </div>

      {/* Kurulu Bildirimler ve Geçmiş Bildirimler Alanları */}
      <div className="w-full md:w-1/2 flex flex-col gap-4">
        <div className="p-4 bg-white rounded-lg shadow">
          <h2 className="text-lg font-bold mb-4">Kurulu Bildirimler</h2>
          {notifications.length === 0 ? (
            <p className="text-gray-500">Henüz kurulu bir bildirim yok.</p>
          ) : (
            <ul className="list-disc pl-4">
              {notifications.map((notif, index) => (
                <li key={index} className="mb-2">
                  <b>{notif.title}</b> - {notif.content} - {notif.dateTime} -{" "}
                  {notif.repeat}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className="p-4 bg-white rounded-lg shadow">
          <h2 className="text-lg font-bold mb-4">Geçmiş Bildirimler</h2>
          {notificationHistory.length === 0 ? (
            <p className="text-gray-500">Henüz gönderilmiş bir bildirim yok.</p>
          ) : (
            <ul className="list-disc pl-4">
              {notificationHistory.map((notif, index) => (
                <li key={index} className="mb-2">
                  <b>{notif.title}</b> - {notif.content} - {notif.timeSent}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

export default Bildirimler;
